
export const getUpsertPolicySimpleClaimFieldValues = () => ({
  claims: [],
})